import React from 'react';
import { Typography, Button } from '@navi/web-ui/lib/primitives';
import { ArrowLeftSolidIcon, ArrowRightSolidIcon } from '@navi/web-ui/lib/icons';
import { StrategyNavigationHeaderProps, AllocationDpdFilter, StrategyType } from '../types';
import StrategyFilterPopper from './StrategyFilterPopper';
import CaseRecommendationCallingIcon from '@cp/src/assets/icons/CaseRecommendationCallingIcon';

const StrategyNavigationHeader: React.FC<StrategyNavigationHeaderProps> = ({
  strategyType,
  totalCasesInStrategy,
  currentPositionInStrategy,
  allocationDpdFilter,
  onFilterChange,
  onPrevious,
  onNext,
  isPrevDisabled = false,
  isNextDisabled = false
}) => {
  const handleFilterApply = (newDpdFilter: AllocationDpdFilter, newStrategy: StrategyType) => {
    if (onFilterChange) {
      onFilterChange(newDpdFilter, newStrategy);
    }
  };

  return (
    <div className="flex flex-row items-center justify-between px-4 py-3 bg-[var(--bg-blue)] border-0 border-t border-solid border-[var(--blue-border)] ">
      <div className="flex flex-col items-center gap-3">
        <CaseRecommendationCallingIcon />
        <Typography variant="p3" color="var(--grayscale-2)">
          Case {currentPositionInStrategy} of {totalCasesInStrategy}
        </Typography>
      </div>

      <div className="flex flex-col items-center gap-3">
        {strategyType && (
          <StrategyFilterPopper
            currentDpdFilter={allocationDpdFilter}
            currentStrategy={strategyType}
            onApply={handleFilterApply}
          />
        )}

        <div className="flex items-center gap-2">
          <Button
            variant="secondary"
            size="small"
            onClick={onPrevious}
            startAdornment={<ArrowLeftSolidIcon />}
            disabled={isPrevDisabled}
          >
            Prev
          </Button>
          <Button
            variant="secondary"
            size="small"
            onClick={onNext}
            endAdornment={<ArrowRightSolidIcon />}
            disabled={isNextDisabled}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StrategyNavigationHeader;
